import { useEffect } from "react";
import { useAuthContext } from "./AuthContext";
import { useUserStore } from "../store/store";

const AuthSync = () => {
    const { userInfo, isUserLogin } = useAuthContext();
    const [setUser, setPermission] = useUserStore((state) => [
        state.setUser,
        state.setPermission,
    ]);

    useEffect(() => {
        if (isUserLogin && userInfo) {
            setUser({
                ...userInfo,
                phone_num: userInfo.phone,
            });
            setPermission(userInfo.site_permission);
        } else {
            setUser(null);
            setPermission(null);
        }
    }, [isUserLogin, userInfo, setUser, setPermission]);

    return null;
};

export default AuthSync;
